export default {"src":"/_next/static/media/Trivision-blacktext.7bfe78e4.svg","height":173,"width":760,"blurWidth":0,"blurHeight":0};